import { motion } from "framer-motion";
import { useLang } from "../i18n";
import ChapterHeading from "./ChapterHeading";
import { portraitImage } from "../data";

export default function About() {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" data-testid="about-section" className="py-32 md:py-48 bg-linen2 border-y border-black/10">
      <ChapterHeading num={a.num} title={a.title} note="Jeanne Leveque" testid="about-heading" />
      <div className="px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-5"
        >
          <div className="md:sticky md:top-32">
            <div className="relative overflow-hidden border border-black/15 aspect-[3/4] group">
              <img
                src={portraitImage}
                alt={a.caption}
                loading="lazy"
                className="h-full w-full object-cover grayscale-[30%] sepia-[12%] transition-[filter,transform] duration-700 group-hover:grayscale-0 group-hover:sepia-0 group-hover:scale-105"
              />
            </div>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-black/50">
              {a.caption}
            </p>
          </div>
        </motion.div>

        <div className="md:col-span-6 md:col-start-7 flex flex-col gap-10">
          {[a.p1, a.p2].map((p, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`about-paragraph-${i}`}
              className="font-serif text-2xl md:text-[2rem] leading-snug text-black/85"
            >
              {p}
            </motion.p>
          ))}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.3 }}
            className="font-serif text-3xl md:text-4xl text-ink"
          >
            {a.p3}
          </motion.p>
          <motion.img
            src="/images/signature.png"
            alt="Signature de Jeanne Leveque"
            data-testid="about-signature"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="h-16 md:h-20 w-auto self-start"
          />
        </div>
      </div>
    </section>
  );
}
